import { MenuItemInfo } from '@tableau/widgets';
import React, { CSSProperties } from 'react';
import _ from 'underscore';

import { Messages } from '~src/codegen/Localize';
import { ButtonControlledFlyoutListMenu } from '~src/commonInfra/components/ButtonControlledFlyoutListMenu';
import { Icons } from '~src/commonInfra/components/Icons';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { ExplorerDropdown } from '~src/spacesPlatform/components/Explorer/widgets/ExplorerDropdown';
import { ExplorerFlyoutPanelProps } from '~src/spacesPlatform/components/Explorer/widgets/ExplorerFlyoutPanel';

export type ActionsMenuItem = {
  label: string;
  disabled?: boolean;
  execute: () => {};
};

export type AuthenticationActionsMenuProps = {
  readonly actions: ActionsMenuItem[];
  readonly style?: React.CSSProperties;
  readonly disabled?: boolean; // passed through to ButtonControlledComponent, which defaults to false
  readonly useIcon: boolean; // This will use the '...' icon and no caret instead of text
  readonly buttonTitle?: string;
  readonly tabIndex?: number;
};

const IconButtonStyleOverrides: CSSProperties = {
  minWidth: 0,
  height: 24,
  width: 24,
  padding: 0,
};

const MenuStyleOverrides: CSSProperties = {
  minWidth: 48,
  width: 170,
  padding: 0,
};

// Based on ActionsMenu.tsx
export class AuthenticationActionsMenu extends React.Component<AuthenticationActionsMenuProps> {

  public render(): JSX.Element {
    return (
      <ExplorerDropdown
        buttonTitle={this.props.buttonTitle || Messages.moreActions()}
        testId={'AuthenticationActionsMenuTestId'}
        renderButtonContent={this.renderButtonContent}
        renderPanel={this.renderPanel}
        disabled={this.props.disabled}
        panelTitle={Messages.actionsMenu()}
        buttonStyleOverrides={IconButtonStyleOverrides}
        renderButtonContentOnly={this.props.useIcon}
        tabIndex={this.props.tabIndex}
      />
    );
}

  private renderButtonContent = (showingOrActive: boolean): JSX.Element => {
    if (this.props.useIcon) {
      const styleOverrides: React.CSSProperties = {
        opacity: this.props.disabled ? CommonStyles.Opacity.DisabledOpacity : undefined,
        verticalAlign: 'middle'
      };

      return (
        <Icons.actionIcon hovered={ showingOrActive }
                          suppressHover={ this.props.disabled }
                          style={ styleOverrides }
        />
      );
    } else {
      return <span>{Messages.actions()}</span>;
    }
  };

  private renderPanel = (props: ExplorerFlyoutPanelProps): JSX.Element => {
    return getActionsMenuChildComponent(props, this.props.actions);
  };
}

function getActionsMenuChildComponent(
  props: ExplorerFlyoutPanelProps,
  actions: ReadonlyArray<ActionsMenuItem>
): JSX.Element {
  const menuItems: MenuItemInfo[] = actions.map((action, index) => ({
    disabled: action.disabled,
    displayValue: action.label,
    value: `${index}`,
    subMenuStyle: { minHeight: 35, height: 35 }
  }));
  const itemSelected = (value: string) => {
    const index = parseInt(value, 10);
    const action = actions[index];
    if (action) {
      action.execute();
    }
  };
  return <ButtonControlledFlyoutListMenu
    onComponentDidMount={_.noop}
    menuItems={menuItems}
    onMenuItemSelected={itemSelected}
    anchorElement={props.anchorEl}
    closeMe={props.onCloseRequest}
    testId={'action-menu-wrapper'}
    menuStyle={MenuStyleOverrides}
  />;
}
